import { useSelector } from 'react-redux';

import { StoreState } from '~/reducer';
import { unitPositionsStateSelector } from '~/selectors';

import { UnitPosition } from './types';

export const useAllUnitPositions = (): {
  unitPositions: UnitPosition[];
  isLoading: boolean;
  failedToLoad: boolean;
  hasData: boolean;
} => {
  return useSelector((state: StoreState) => {
    return unitPositionsStateSelector(state);
  });
};
